import { TileLayer } from 'react-leaflet'

const GoogleMapLayer = () => {
  return (
    <TileLayer
      maxZoom={20}
      zIndex={200}
      attribution="Google Maps"
      url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
    />
  )
}

export default GoogleMapLayer